/**
 * "1234-giata" -> "1234"
 */
export const fromGiataToRaw = (hotelId: string): string => {
  return hotelId.replace('-giata', '');
};

/**
 * "1234-giata" -> "hotel-1234"
 */
export const fromGiataToKeyword = (hotelId: string): string => {
  return `hotel-${fromGiataToRaw(hotelId)}`;
};

/**
 * "hotel-1234" -> "1234-giata"
 */
export const fromKeywordToGiata = (hotelId: string): string => {
  return `${hotelId.replace('hotel-', '')}-giata`;
};
